import initialState from './initialState';
import { reducer as loadProjectCollectionsReducer } from './loadProjectCollections';
import { reducer as loadProjectCollectionDetailReducer } from './loadProjectCollectionDetail';
import { reducer as updateCollectionsReducer } from './updateCollections';
import { reducer as createCollectionReducer } from './createCollection';
import { reducer as deleteCollectionReducer } from './deleteCollection';
import { reducer as editFieldReducer } from './editField';
import { reducer as deleteFieldReducer } from './deleteField';
import { reducer as createNewFieldReducer } from './createNewField';
import { reducer as deleteConstructorReducer } from './deleteConstructor';
import { reducer as createCollectionConstructorReducer } from './createCollectionConstructor';
import { reducer as addUtilityFunctionToCollectionReducer } from './addUtilityFunctionToCollection';
import { reducer as deleteUitilityFunctionReducer } from './deleteUitilityFunction';
import { reducer as updateConstantOfCollectionReducer } from './updateConstantOfCollection';
import { reducer as deleteCollectionConstantReducer } from './deleteCollectionConstant';
import { reducer as createCollectionConstantReducer } from './createCollectionConstant';
import { reducer as addQueryToCollectionReducer } from './addQueryToCollection';
import { reducer as updateQueryOfCollectionReducer } from './updateQueryOfCollection';
import { reducer as deleteCollectionQueryReducer } from './deleteCollectionQuery';
import { reducer as updateConstraintOfCollectionReducer } from './updateConstraintOfCollection';
import { reducer as deleteCollectionConstraintReducer } from './deleteCollectionConstraint';
import { reducer as createCollectionConstraintReducer } from './createCollectionConstraint';
import { reducer as addRuleToCollectionReducer } from './addRuleToCollection';
import { reducer as deleteCollectionValidationReducer } from './deleteCollectionValidation';
import { reducer as loadCollectionItemsReducer } from './loadCollectionItems';
import { reducer as saveCollectionItemReducer } from './saveCollectionItem';
import { reducer as updateCollectionItemReducer } from './updateCollectionItem';
import { reducer as deleteItemReducer } from './deleteItem';
import { reducer as loadItemDetailsReducer } from './loadItemDetails';
import { reducer as loadCollectionItemReducer } from './loadCollectionItem';
import { reducer as closeItemDetailPageReducer } from './closeItemDetailPage';
import { reducer as toggleCollectionUpdateReducer } from './toggleCollectionUpdate';
import { reducer as deleteAllItemsReducer } from './deleteAllItems';
import { reducer as addWorkflowToCollectionReducer } from './addWorkflowToCollection';
import { reducer as deleteCollectionWorkflowReducer } from './deleteCollectionWorkflow';
import { reducer as loadFilterDataReducer } from './loadFilterData';
import { reducer as loadProjectPluginsReducer } from './loadProjectPlugins';
import { reducer as loadProjectDetailCollectionsReducer } from './loadProjectDetailCollections';
import { reducer as createCollectionWithCsvReducer } from './createCollectionWithCsv';
import { reducer as toggleIsOpenCollectionCreateWithCsvReducer } from './toggleIsOpenCollectionCreateWithCsv';
import { reducer as isOpenCollectionCreateWithRestApiReducer } from './isOpenCollectionCreateWithRestApi';
import { reducer as responceForRestApiReducer } from './responceForRestApi';
import { reducer as saveDataInExternaldatabaseReducer } from './saveDataInExternaldatabase';
import { reducer as loadExternalDatabaseReducer } from './loadExternalDatabase';
import { reducer as updateExternalDatabaseReducer } from './updateExternalDatabase';
import { reducer as cloneCollectionReducer } from './cloneCollection';
import { reducer as createCollectionWithJsonReducer } from './createCollectionWithJson';
import { reducer as importItemsFromJsonReducer } from './importItemsFromJson';
import { reducer as importItemsFromRestApiReducer } from './importItemsFromRestApi';
import { reducer as deleteCollectionValidationRulesReducer } from './deleteCollectionValidationRules';
import { reducer as addSingleValidationRuleReducer } from './addSingleValidationRule';
import { reducer as updateLookupReducer } from './updateLookup';
import { reducer as enableLookupSettingReducer } from './enableLookupSetting';
import { reducer as getPermissionFlagsReducer } from './getPermissionFlags';
import { reducer as updateFilterDetailsReducer } from './updateFilterDetails';
import { reducer as createCollectionSnapshotReducer } from './createCollectionSnapshot';
import { reducer as loadCollectionSnapshotsReducer } from './loadCollectionSnapshots';
import { reducer as createPermissionLevelSecurityInCollectionReducer } from './createPermissionLevelSecurityInCollection';
import { reducer as createRowLevelSecurityFilterInCollectionReducer } from './createRowLevelSecurityFilterInCollection';
import { reducer as deleteRowLevelSecurityFilterReducer } from './deleteRowLevelSecurityFilter';
import { reducer as updateTableSettingsReducer } from './updateTableSettings';
import { reducer as getTableSettingsReducer } from './getTableSettings';
import { reducer as createTypesenseMappingInCollectionReducer } from './createTypesenseMappingInCollection';
import { reducer as generateCrudPagesReducer } from './generateCrudPages';
import { reducer as createCollectionWithPromptReducer } from './createCollectionWithPrompt';
import { reducer as extractFieldsFromPromptReducer } from './extractFieldsFromPrompt';
import { reducer as extractCollectionDataReducer } from './extractCollectionData';
import { reducer as generateCollectionDataReducer } from './generateCollectionData';
import { reducer as createMetaDataMappingInCollectionReducer } from './createMetaDataMappingInCollection';
import { reducer as deleteCollectionMetaDataTableMappingReducer } from './deleteCollectionMetaDataTableMapping';
import { reducer as updateCollectionMetaDataTableMappingReducer } from './updateCollectionMetaDataTableMapping';

const reducers = [
  loadProjectCollectionsReducer,
  loadProjectCollectionDetailReducer,
  updateCollectionsReducer,
  createCollectionReducer,
  deleteCollectionReducer,
  editFieldReducer,
  deleteFieldReducer,
  createNewFieldReducer,
  deleteConstructorReducer,
  createCollectionConstructorReducer,
  addUtilityFunctionToCollectionReducer,
  deleteUitilityFunctionReducer,
  updateConstantOfCollectionReducer,
  deleteCollectionConstantReducer,
  createCollectionConstantReducer,
  addQueryToCollectionReducer,
  updateQueryOfCollectionReducer,
  deleteCollectionQueryReducer,
  updateConstraintOfCollectionReducer,
  deleteCollectionConstraintReducer,
  createCollectionConstraintReducer,
  addRuleToCollectionReducer,
  deleteCollectionValidationReducer,
  loadCollectionItemsReducer,
  saveCollectionItemReducer,
  updateCollectionItemReducer,
  deleteItemReducer,
  loadItemDetailsReducer,
  loadCollectionItemReducer,
  closeItemDetailPageReducer,
  toggleCollectionUpdateReducer,
  deleteAllItemsReducer,
  addWorkflowToCollectionReducer,
  deleteCollectionWorkflowReducer,
  loadFilterDataReducer,
  loadProjectPluginsReducer,
  loadProjectDetailCollectionsReducer,
  createCollectionWithCsvReducer,
  toggleIsOpenCollectionCreateWithCsvReducer,
  isOpenCollectionCreateWithRestApiReducer,
  responceForRestApiReducer,
  saveDataInExternaldatabaseReducer,
  loadExternalDatabaseReducer,
  updateExternalDatabaseReducer,
  cloneCollectionReducer,
  createCollectionWithJsonReducer,
  importItemsFromJsonReducer,
  importItemsFromRestApiReducer,
  deleteCollectionValidationRulesReducer,
  addSingleValidationRuleReducer,
  updateLookupReducer,
  enableLookupSettingReducer,
  getPermissionFlagsReducer,
  updateFilterDetailsReducer,
  createCollectionSnapshotReducer,
  loadCollectionSnapshotsReducer,
  createPermissionLevelSecurityInCollectionReducer,
  createRowLevelSecurityFilterInCollectionReducer,
  deleteRowLevelSecurityFilterReducer,
  updateTableSettingsReducer,
  getTableSettingsReducer,
  createTypesenseMappingInCollectionReducer,
  generateCrudPagesReducer,
  createCollectionWithPromptReducer,
  extractFieldsFromPromptReducer,
  extractCollectionDataReducer,
  generateCollectionDataReducer,
  createMetaDataMappingInCollectionReducer,
  deleteCollectionMetaDataTableMappingReducer,
  updateCollectionMetaDataTableMappingReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
